
import React from 'react';

const BenefitsSection: React.FC = () => {
  const benefits = [
    {
      icon: "ri-shield-check-line",
      title: "Prevents Water Damage",
      description: "Keeps gutters flowing properly to protect your foundation, basement, and landscaping from costly water damage."
    },
    {
      icon: "ri-tools-line",
      title: "Easy DIY Installation",
      description: "No special tools required. Simply place in gutters - you can do it yourself in no time."
    },
    {
      icon: "ri-leaf-line",
      title: "Blocks Debris, Allows Water",
      description: "Innovative brush design stops leaves and debris while allowing water to flow freely through gutters."
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Saves Money Long-term",
      description: "Eliminate expensive professional cleaning costs and prevent costly water damage repairs."
    },
    {
      icon: "ri-time-line",
      title: "Minimal Maintenance",
      description: "Once installed, requires virtually no maintenance. No more dangerous ladder climbing or seasonal cleaning."
    },
    {
      icon: "ri-flag-line",
      title: "Made in USA Since 2004",
      description: "American-made quality you can trust. Proven performance for nearly two decades."
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Why Choose GutterBrush Simple Gutter Guards?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            The smart solution that saves you time, money, and keeps your family safe 
            while protecting your home's value.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center p-6 rounded-lg hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${benefit.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gray-50 rounded-lg p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-orange-500 mb-2">90%</div>
              <p className="text-gray-600">Less expensive than Leaf Filters</p>
            </div>
            <div>
              <div className="text-3xl font-bold text-orange-500 mb-2">DIY Simple!</div>
              <p className="text-gray-600">No tools, cutting, fasteners</p>
            </div>
            <div>
              <div className="text-3xl font-bold text-orange-500 mb-2">6</div>
              <p className="text-gray-600">Diameter options available</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
